import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const questionsModel = [
  {
    field: 'zalud_general_locationTxFl',
    label: 'Are you physically located in Texas or Florida?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_general_sexAssignedAtBirth',
    label: 'What sex were you assigned at birth?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Female', key: 'female' },
        { value: 'Male', key: 'male' }
      ]
    }
  },
  {
    field: 'zalud_general_pregnant',
    label: 'Are you currently pregnant?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_general_breastfeeding',
    label: 'Are you currently breastfeeding?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_general_height',
    label: 'What is your height?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'zalud_general_height',
      placeholder:
        'Enter in feet and inches (e.g. 5 ft 10 in) or meters and cm (e.g. 178 cm)'
    }
  },
  {
    field: 'zalud_general_weight',
    label: 'What is your weight?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'zalud_general_weight',
      placeholder: 'Enter in pounds (lbs) or kilograms (kg)'
    }
  },
  {
    field: 'zalud_general_medicationAllergies',
    label: 'Do you have any allergies to medications?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'No known allergies',
          key: 'none'
        },
        {
          value: 'Yes',
          key: 'yes',
          answer: {
            type: 'text',
            name: 'zalud_general_medicationAllergies',
            rows: 4,
            placeholder: 'Please list your medication allergies'
          }
        }
      ]
    }
  },
  {
    field: 'zalud_general_surgeries',
    label: 'Have you had any surgeries?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'None', key: 'none' },
        {
          value: 'Yes',
          key: 'yes',
          answer: {
            type: 'list',
            items: [
              {
                type: 'date',
                name: 'zalud_general_surgeriesDate',
                placeholder: 'Date'
              },
              {
                type: 'text',
                name: 'zalud_general_surgeriesComplications',
                placeholder: 'Any Complications?',
                rows: 4
              }
            ]
          }
        }
      ]
    }
  },
  {
    field: 'zalud_general_currentMedications',
    label: 'Are you currently taking any medications?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Not taking any medications', key: 'none' },
        {
          value: 'Yes',
          key: 'yes',
          answer: {
            type: 'text',
            name: 'zalud_general_currentMedications',
            rows: 4,
            placeholder: 'Please list your current medications'
          }
        }
      ]
    }
  },
  {
    field: 'zalud_general_supplements',
    label: 'Are you currently taking any supplements?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Not taking any supplements', key: 'none' },
        {
          value: 'Yes',
          key: 'yes',
          answer: {
            type: 'text',
            name: 'zalud_general_supplements',
            rows: 4,
            placeholder: 'Please list your current supplements'
          }
        }
      ]
    }
  },
  {
    field: 'zalud_general_medicalConditions',
    label:
      'Please list any medical conditions you currently have that were diagnosed by a physician or medical provider',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'zalud_general_medicalConditions'
    }
  },
  {
    field: 'zalud_general_conditionsHistory',
    label:
      'Do you currently have, or have you ever had, any of the following conditions?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'HIV', key: 'hiv' },
        { value: 'Cancer', key: 'cancer' },
        { value: 'Currently undergoing chemotherapy', key: 'chemotherapy' },
        {
          value: 'Currently undergoing radiation therapy',
          key: 'radiation_therapy'
        },
        { value: 'History of organ transplant', key: 'organ_transplant' },
        { value: 'Current long-term steroid use', key: 'steroid_use' },
        { value: 'End stage renal disease', key: 'renal_disease' },
        { value: 'End stage liver disease', key: 'liver_disease' },
        { value: 'Currently requiring hemodialysis', key: 'hemodialysis' },
        { value: 'Uncontrolled diabetes', key: 'uncontrolled_diabetes' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_general_cancerStatus',
    label: 'Is your cancer active or in remission?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Active', key: 'active' },
        { value: 'In remission', key: 'in_remission' }
      ]
    }
  },
  {
    field: 'zalud_general_tobaccoNicotineUse',
    label:
      'Do you use tobacco or nicotine products (cigarettes, vaping/e-cigarettes, cigars, chew, etc.)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No, never', key: 'never' },
        { value: 'Former user', key: 'former_user' },
        {
          value: 'Occasional (3 days/week or less)',
          key: 'occasional'
        },
        { value: 'Daily, most days', key: 'daily' }
      ]
    }
  },
  {
    field: 'zalud_general_alcoholUse',
    label: 'How often do you consume alcoholic drinks?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Never', key: 'never' },
        {
          value: 'Occasionally (1–2 days per week)',
          key: 'occasionally'
        },
        {
          value: 'Regularly (3–5 days per week)',
          key: 'regularly'
        },
        {
          value: 'Daily/heavily (6+ days per week or multiple drinks daily)',
          key: 'daily_heavily'
        }
      ]
    }
  },
  {
    field: 'zalud_general_languagePreference',
    label: 'What language do you prefer to be contacted in by our medical team?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'English', key: 'english' },
        { value: 'Spanish', key: 'spanish' }
      ]
    }
  },
  {
    field: 'zalud_general_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'zalud_general_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to continue based on your responses.",
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type ZaludGeneralQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModel>
>;
export default questionsModel;
